// src/data/themes.js
import { literature } from "./topics/literature";
import { marineLife } from "./topics/marineLife";
import { forestAnimals } from "./topics/forestAnimals";
// import { europe } from "./topics/europe";

export const themes = {
  literature,
  marineLife,
  forestAnimals,
  // europe,
};
